<template>
  <div>
    <ForeignOrganizationFields :v="v" />
    <MrpaTrustee
      :v="v.trustee"
      label="Сведения о представителе юридического лица"
    />
  </div>
</template>

<script>
import ForeignOrganizationFields, {
  foreignOrganizationFieldsModel,
  foreignOrganizationFieldsValidation,
} from '@/components/services/ExtractionRod/Applicant/ForeignOrganizationFields';
import MrpaTrustee, {
  mrpaTrusteeModel,
  getMrpaTrusteeValidation,
} from '@/components/services/elements/MrpaTrustee';
import cloneDeep from 'clone-deep';

export const machineForeignOrganizationModel = {
  ...foreignOrganizationFieldsModel,
  trustee: cloneDeep(mrpaTrusteeModel),
};

export const getMachineForeignOrganizationValidation = (foreignOrganization) => ({
  ...foreignOrganizationFieldsValidation,
  trustee: getMrpaTrusteeValidation(foreignOrganization.trustee),
});

export default {
  name: 'ForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    ForeignOrganizationFields,
    MrpaTrustee,
  },
};
</script>
